var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#F5F5F5"}},[_c('a-page-header',{attrs:{"ghost":false,"title":"事件","sub-title":"详细事件","backIcon":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }